import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { ReactElement, useCallback, useEffect, useState } from 'react';

interface CreateConfirmModalProps {
  onClose: () => void;
  onSubmit?: () => void;
  open: boolean;
}

export function CreateConfirmModal({
  onClose,
  onSubmit,
  open,
}: CreateConfirmModalProps): ReactElement {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = useCallback((): void => {
    onClose();
  }, [onClose]);

  const handleClickSubmit = () => {
    setIsLoading(true);
    onSubmit && onSubmit();
  };

  useEffect(() => {
    if (!open) {
      setIsLoading(false);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Typography mb={3}>応募してよろしいでしょうか？</Typography>
        <Typography variant="body2">
          応募されたことが通知され、あなたの登録情報や添付資料などが医療機関へ共有されます。
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="inherit"
          variant="outlined"
          fullWidth
          onClick={handleClose}
        >
          キャンセル
        </Button>
        <LoadingButton
          color="black"
          variant="contained"
          loading={isLoading}
          fullWidth
          onClick={handleClickSubmit}
        >
          応募する
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
